/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'

export default {
  addItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/data-list/products/', {item})
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItems ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/data-list/products')
        .then((response) => {
          commit('SET_PRODUCTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // fetchEventLabels({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     axios.get("/api/apps/calendar/labels")
  //       .then((response) => {
  //         commit('SET_LABELS', response.data)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  updateItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/data-list/products/${item.id}`, {item})
        .then((response) => {
          commit('UPDATE_PRODUCT', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItem ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/data-list/products/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  //STUDENTS ACTIONS
  addStudent ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/data-list/students/', {item})
        .then((response) => {
          commit('ADD_STUDENT', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListStudents ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/data-list/students')
        .then((response) => {
          commit('SET_STUDENTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateStudent ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/data-list/students/${item.id}`, {item})
        .then((response) => {
          commit('UPDATE_STUDENT', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeStudent ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/data-list/students/${itemId}`)
        .then((response) => {
          commit('REMOVE_STUDENT', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  //CAM USERS ACTIONS
  addCamUser ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/data-list/cam_users/', {item})
        .then((response) => {
          commit('ADD_CAMUSER', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListCamUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/data-list/cam_users')
        .then((response) => {
          commit('SET_CAMUSERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCamUser ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/data-list/cam_users/${item.id}`, {item})
        .then((response) => {
          commit('UPDATE_CAMUSER', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeCamUser ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/data-list/cam_users/${itemId}`)
        .then((response) => {
          commit('REMOVE_CAMUSER', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  //LOCATIONS ACTIONS
  addLocation ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/data-list/locations/', {item})
        .then((response) => {
          commit('ADD_LOCATION', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListLocation ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/data-list/locations')
        .then((response) => {
          commit('SET_LOCATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateLocation ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/data-list/locations/${item.id}`, {item})
        .then((response) => {
          commit('UPDATE_LOCATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeLocation ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/data-list/locations/${itemId}`)
        .then((response) => {
          commit('REMOVE_LOCATION', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  //MANAGERS ACTIONS
  addManager ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/data-list/managers/', {item})
        .then((response) => {
          commit('ADD_MANAGER', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListManager ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/data-list/managers')
        .then((response) => {
          commit('SET_MANAGER', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateManager ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/data-list/manager/${item.id}`, {item})
        .then((response) => {
          commit('UPDATE_MANAGER', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeManager ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/data-list/manager/${itemId}`)
        .then((response) => {
          commit('REMOVE_MANAGER', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  //PROGARMS ACTIONS
  addProgram ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/data-list/programs/', {item})
        .then((response) => {
          commit('ADD_PROGRAM', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListProgram ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/data-list/programs')
        .then((response) => {
          commit('SET_PROGRAM', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateProgram ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/data-list/program/${item.id}`, {item})
        .then((response) => {
          commit('UPDATE_PROGRAM', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeProgram ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/data-list/program/${itemId}`)
        .then((response) => {
          commit('REMOVE_PROGRAM', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  //SCHEDULE ACTIONS
  addSchedule ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/data-list/schedules/', {item})
        .then((response) => {
          commit('ADD_SCHEDULE', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListSchedule ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/data-list/schedules')
        .then((response) => {
          commit('SET_SCHEDULE', response.data)
          resolve(response)
          console.log(response)

        })
        .catch((error) => { reject(error) })
    })
  },
  updateSchedule ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/data-list/schedules/${item.id}`, {item})
        .then((response) => {
          commit('UPDATE_SCHEDULE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeSchedule ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/data-list/schedules/${itemId}`)
        .then((response) => {
          commit('REMOVE_SCHEDULE', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  //SCHEDULE CAMERAS
  addCamera ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/data-list/cameras/', {item})
        .then((response) => {
          commit('ADD_CAMERA', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListCamera ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/data-list/cameras')
        .then((response) => {
          commit('SET_CAMERA', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateCamera ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/data-list/cameras/${item.id}`, {item})
        .then((response) => {
          commit('UPDATE_CAMERA', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeCamera ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/data-list/cameras/${itemId}`)
        .then((response) => {
          commit('REMOVE_CAMERA', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }

  // eventDragged({ commit }, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`/api/apps/calendar/event/dragged/${payload.event.id}`, {payload: payload})
  //       .then((response) => {

  //         // Convert Date String to Date Object
  //         let event = response.data
  //         event.startDate = new Date(event.startDate)
  //         event.endDate = new Date(event.endDate)

  //         commit('UPDATE_EVENT', event)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
}
